import { FormConfig } from '@frontend/design-system';
import { switchField, textField } from '../../utils/field-config-helpers';

export type OnlineBookingFieldTypes = typeof onlineBookingConfigs;

export const onlineBookingConfigs = {
  enableOnlineBooking: switchField(),
  actionColorPicker: textField(),
  backgroundColorPicker: textField(),
  logoUrl: textField(),
} satisfies FormConfig;
